
import { CSSProperties } from "react"

export const ListItembuttonStyle  : CSSProperties = {
    textTransform: 'none',
}

export const ListItemIconStyle  : CSSProperties = {
    marginRight: 10,
    marginLeft: 10,
    fontSize: 14,  
    color: 'rgba(0, 0, 0, 0.6)',  
}

export const MenuListItemIconStyle  : CSSProperties = {
    padding: 0,
    fontSize: 14,  
    color: 'rgba(0, 0, 0, 0.6)',  
}

export const ListTypographyStyle  : CSSProperties = {
    display: "block",
    color: 'rgba(0, 0, 0, 0.6)',
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontSize: 14,
}

export const ListItemTextStyle : CSSProperties = { }

export const MenuItemStyle : CSSProperties = {
    paddingTop: 7,
    paddingBottom: 7,
}

export const DividerStyle : CSSProperties = { }

export const AvatarAppBarStyle : CSSProperties = {
    width: 20,
    height: 20,
}

export const TypographyAppBarStyle : CSSProperties = {    
    width: 220,
    color: 'rgba(0, 0, 0, 0.6)',
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontSize: 16,
}

export const TypographyPerfilAppBarStyle : CSSProperties = {    
    color: 'rgba(0, 0, 0, 0.6)', 
}

export const ListSubItemStyle : CSSProperties = {    
    alignItems: "center", 
    width: "180px", 
    paddingTop: '10px',
    paddingBottom: '10px',
    color: "inherit", 
    textDecoration: "none"
}